// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import {
    GET_SHIPPING_ACCESSORY_OFFER_DATA,
    GET_SHIPPING_DEVICE_OFFER_DATA,
} from './../../../store/orderCreation';

import { takeLatest } from 'redux-saga/effects';

import {
    getShippingAccessoriesOffer,
    getShippingDeviceOffer,
} from './shippingOffer';

export default [
    takeLatest(GET_SHIPPING_ACCESSORY_OFFER_DATA, getShippingAccessoriesOffer),
    takeLatest(GET_SHIPPING_DEVICE_OFFER_DATA, getShippingDeviceOffer),
];
